import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { Input as CoreInput } from '@sparefoot/react-core';
import { Text } from '../Typography';

import './MultiSelect.scss';

const MultiSelectOption = ({
	name, multiple, label, selected, value, onChange, segmentLabel
}) => {
	const inputId = `${name}-${value}`;
	return (
		<label htmlFor={inputId} className={classnames('option', { selected })}>
			<CoreInput
				value={value}
				onChange={onChange}
				checked={selected}
				name={name}
				id={inputId}
				segmentLabel={`${segmentLabel}-${value}`}
				type={multiple ? 'checkbox' : 'radio'}
			/>
			<Text last weight={selected ? 'bold' : 'standard'}>
				{label}
			</Text>
		</label>
	);
};

MultiSelectOption.propTypes = {
	segmentLabel: PropTypes.string.isRequired,
	multiple: PropTypes.bool.isRequired,
	selected: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired
};

export { MultiSelectOption };
